import React from 'react';

interface CheckSVGProps {
	class: string;
}

/**
 * Check SVG
 *
 * @returns
 */
function CheckSVG(props: CheckSVGProps) {
	return (
		<svg viewBox="0 0 38 32" className={'icon icon-check ' + props.class} focusable="false" aria-hidden="true">
			<path d="M9.67 30.659l-9.121-11.804c-2.146-5.581 2.468-7.513 5.901-4.292l5.903 7.511 18.243-20.388c3.219-3.38 8.585-1.449 6.438 3.755l-21.462 24.679c-2.307 2.683-4.292 2.146-5.902 0.537z" />
		</svg>
	);
}

// Set default props
CheckSVG.defaultProps = {
	class: '',
};

export default CheckSVG;
